export default {
    'halls.loading': 'ローディング',
    'halls.primary.title': '練習',
    'halls.middle.title': 'エキスパート',
    'halls.high.title': 'エリート',
    'halls.top.title': 'マスター',
    'halls.level.describe': 'ホール条件',
    'halls.coin.not': 'コイン不足',
    'halls.setting.title': '設定',
};